import React from 'react'
import {
  List, Datagrid, TextField, Create, SimpleForm, TextInput
} from 'admin-on-rest'

const validateSettings = (values) => {
  const errors = {}
  if (!values.name) {
    errors.name = ['O Nome é obrigatório!']
  }
  if (!values.description) {
    errors.description = ['A Descrição é obrigatória!']
  }
  return errors
}

export const SettingsList = (props) => (
  <List {...props} title='Configurações'>
    <Datagrid>
      <TextField label='Nome' source='name' />
      <TextField label='Descrição' source='description' />
    </Datagrid>
  </List>
)

export const SettingsCreate = (props) => (
  <Create {...props} title='Criar Configuração'>
    <SimpleForm validate={validateSettings}>
      <TextInput label='Nome' source='name' options={{ fullWidth: true }} />
      <TextInput label='Descrição' source='description' options={{ fullWidth: true }} />
    </SimpleForm>
  </Create>
)



// WEBPACK FOOTER //
// ./src/collections/settings.js